module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.withSectionsSelector) ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('h3', [_vm._v("Application " + _vm._s(_vm.application.id) + ": " + _vm._s(_vm.application.licence_type_short_name))])]) : _vm._e(), _vm._v(" "), (_vm.withSectionsSelector) ? _c('div', {
    staticClass: "col-md-3 sections-dropdown"
  }, [_c('affix', {
    staticClass: "sections-menu",
    attrs: {
      "relative-element-selector": "#tabs"
    }
  }, [_c('div', {
    staticClass: "panel panel-default fixed"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "open"
  }, [_c('h5', [_vm._v("Sections")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-panel"
  }, _vm._l((_vm.renderer_tabs), function(tab, tab_idx) {
    return _c('li', {
      staticClass: "dropdown-submenu"
    }, [_c('a', {
      staticClass: "section-menu",
      attrs: {
        "tabindex": "-1"
      },
      on: {
        "click": function($event) {
          return _vm.sectionClick(tab)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(tab.name) + "\n                                        "), _c('span', {
      class: ("fa fa-caret-" + (tab.id == _vm.section_tab_id ? 'up': 'down'))
    })]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu-right section-list",
      attrs: {
        "id": "section-submenu"
      }
    }, _vm._l((_vm.getSections(tab.id)), function(section, section_idx) {
      return _c('div', {
        directives: [{
          name: "scroll-to",
          rawName: "v-scroll-to",
          value: (("#" + (section.name))),
          expression: "`#${section.name}`"
        }],
        staticClass: "menu-row",
        on: {
          "click": function($event) {
            return _vm.selectTab(tab)
          }
        }
      }, [_c('div', [_c('i', {
        staticClass: "fa fa-circle"
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(section.label))])])])
    }), 0)])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "0"
    }
  })])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8850de6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/renderer.vue
// module id = 1029
// module chunks = 0